import { type StateCreator } from "zustand";
import type { TBrandingFormData } from "../../api/branding/branding.types";

export type TBrandingStoreState = {
  isBrandingCreated: boolean;
  isBrandingLoading: boolean;
  brandingList: TBrandingFormData;
} & Partial<Record<string, any>>;

export type TBrandingStoreActions = {
  setIsBrandingLoading: (value: boolean) => void;
  setBrandingList: (
    value:
      | Partial<TBrandingFormData>
      | ((prev: TBrandingFormData) => TBrandingFormData),
  ) => void;
  setIsBrandingCreated: (value: boolean) => void;
};
const initialBrandingStoreState: TBrandingStoreState = {
  isBrandingCreated: false,
  isBrandingLoading: false,
  brandingList: {
    brand_name: "",
    logo_main_light: "",
    logo_secondary_light: "",
    favicon_light: "",
    logo_main_dark: "",
    logo_secondary_dark: "",
    favicon_dark: "",
    primary_color_light: "",
    secondary_color_light: "",
    tertiary_color_light: "",
    primary_color_dark: "",
    secondary_color_dark: "",
    tertiary_color_dark: "",
    tagline: "",
    copyright: "",
    custom_css_light: "",
    custom_css_dark: "",
    default_language: "",
    country: "",
  },
};

export type TBrandingStore = TBrandingStoreActions & TBrandingStoreState;

export const CreateBrandingSlice: StateCreator<TBrandingStore> = (set) => ({
  ...initialBrandingStoreState,
  setIsBrandingLoading: (value: boolean) => set({ isBrandingLoading: value }),
  setBrandingList: (value) =>
    set((state) => ({
      brandingList:
        typeof value === "function"
          ? value(state.brandingList)
          : { ...state.brandingList, ...value },
    })),
  setIsBrandingCreated: (value: boolean) => set({ isBrandingCreated: value }),
});
